<template>
  <RegisterPage :errors="errors" :title="$t('Create a recruiter account')" :inviter="inviter" :prefilled-email="prefilledEmail">
    <template #left>
      <LeftRegisterRecruiter />
    </template>

    <template #inputs-hidden>
      <input type="hidden" name="account_type" value="recruiter" />
      <input type="hidden" name="inviter_token" :value="inviter.token" />
    </template>
  </RegisterPage>
</template>

<script>
import LeftRegisterRecruiter from '@/components/auth/left/LeftRegisterRecruiter.vue'
import RegisterPage from '@/components/auth/RegisterPage.vue'

export default {
  name: 'RegisterRecruiterPage',
  components: {
    LeftRegisterRecruiter,
    RegisterPage,
  },
  props: {
    errors: {
      type: Object,
      required: true,
    },
    inviter: {
      type: Object,
      required: true,
      default: {},
    },
    prefilledEmail: {
      type: String,
      required: false
    }
  },
}
</script>
